import React from 'react';
import "../../../../assets/css/mobilegrid.css";
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../../Component/breadcrumb/Breadcrumb';
import Searchlist from '../../../../Component/search/Searchlist';


const products = [
  {
    id: 1,
    name: "ABBY",
    image: "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Abby/1A_DARK_GREY.jpg",
    color: "1A DARK GREY",
    shape: "Rectangle",
    stock: 25,
    price: 8800.00,
    sizes: [
      { id: 23386, label: "80X150" },
      { id: 23381, label: "120X165" },
      { id: 23376, label: "160X230" },
      { id: 23371, label: "200X300" },
      { id: 23366, label: "240X330" },
    ],
  },
  {
    id: 2,
    name: "ABBY",
    image: "https://efi-s3-private.s3.ap-south-1.amazonaws.com/b2b-img/EnvogueImages/Quality/Abby/1A_DARK_GREY.jpg",
    color: "1A DARK GREY",
    shape: "Rectangle",
    stock: 25,
    price: 8800.00,
    sizes: [
      { id: 23386, label: "80X150" },
      { id: 23381, label: "120X165" },
      { id: 23376, label: "160X230" },
      { id: 23371, label: "200X300" },
      { id: 23366, label: "240X330" },
    ],
  },
 
];

function MobileVersionGrid() {
  return (
    <>
      <Breadcrumb/>

      <div className="grid-container-List">
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-9">
              <p className="text-left">Showing 1-{products.length} results for "ABBY"</p>
            </div>
            <div className="col-md-3">
               <Searchlist/>
            </div>
          </div>

          <div className="row gutters-3">
            <div className="col-md-12 col-lg-12">
              <div className="card-body">
                <ul className="list-group list-group-flush list-group-sm">
                  {products.map((product) => (
                    <li className="list-group-item" key={product.id}>
                      <div className="media">
                        <Link to="/">
                               <img src={product.image} alt={product.name} className="card-img-top" />
                          </Link>
                        <div className="media-body">
                          <Link to="/" className="card-link">{product.name}</Link><br />
                          <span>{product.color}</span> <br />
                          <div className="row">
                            <div className="col-12">
                              <div className="d-flex">
                                <span>{product.shape}</span>
                                <div className="stock-info">
                                  <strong> Stock:</strong> <span>{product.stock}</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="font-size-sm mt-2">
                            <div className="row">
                              <div className="col-6">
                                <select className="form-control form-control-sm">
                                  <option value="">Size</option>
                                  {product.sizes.map((size) => (
                                    <option key={size.id} value={size.id}>{size.label}</option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-6">
                                <div className="price">
                                  <i className="bi bi-currency-rupee"></i> {product.price.toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <div className="custom-spinner">
                          <input type="text"   className="form-control form-control-sm" placeholder="" style={{ width:"45px", marginRight:"7px" }}/> 
                          {/* <select name="Qty" className="form-control form-control-sm">
                            {[...Array(7)].map((_, index) => (
                              <option key={index} value={index}>{index}</option>
                            ))}
                          </select> */}
                        </div>

                        <div className="action-buttons">
                          <button className="btn btn-icon btn-text-danger rounded-circle btn-wishlist" title="Add to wishlist">
                            <i className="bi bi-heart"></i>
                          </button>

                          <button type="button" className="btn btn-md has-icon addtocart btn-outline-secondary" title="Add to Cart">
                            <i className="bi bi-cart-plus"></i>
                          </button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default MobileVersionGrid;
